import * as departmentActions from './actions';
import * as departmentActionTypes from './types';
import departmentReducer from './reducers';

const { DEPARTMENT_INIT_STATE } = departmentActionTypes;

export { departmentActions, departmentActionTypes, departmentReducer, DEPARTMENT_INIT_STATE };
